import { UpdateLocationUser } from 'domain/usecases/update-location-user';
import { BaseHttpService } from 'main/factories/http';

export class RemoteUpdateLocationUser extends BaseHttpService<UpdateLocationUser.Model> implements UpdateLocationUser {
  async updateLocationUser(params: UpdateLocationUser.Params): Promise<UpdateLocationUser.Model> {
    const payload = {
      userId: params.userId,
      email: params.email,
      locationId: params.locationId,
      role: params.role,
      emailOptOut: params.emailOptOut,
    };

    return await this.request('post', payload);
  }
}
